module.exports = __webpack_public_path__ + "img/logo-dark.bb160b4d.png";